var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-charging-ans"},[_c('pub-info-title',{attrs:{"title":'用户充电行为分析',"isModal":true}}),_c('div',{ref:"ansLine",staticClass:"power-line-chart"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }